export const reportsRacingSingleCrewSessionPieces = {
    namespaced: true,

    state: {
        filterFields: {
            pieces: []
        },
        filter: {
            pieces: []
        },
        table: {
            selectedSplit: 500,
            selectedTypes: [
                'accumulatedTime',
                'incrementTime',
                'speed',
                'pace',
                'prognostic',
                'strokeRate',
                'eWPS',
                'dps'
            ],
            sortOrder: null
        }
    },

    getters: {
        getFilter(state) {
            return state.filter;
        },

        getFilterFields(state) {
            return state.filterFields;
        },

        selectedSplit(state) {
            return state.table.selectedSplit;
        },

        selectedTypes(state) {
            return state.table.selectedTypes;
        },

        sortOrder(state) {
            return state.table.sortOrder;
        }
    },

    mutations: {
        setSelectedSplit(state, selectedSplit) {
            state.table.selectedSplit = selectedSplit;
        },

        setSortOrder(state, sortOrder) {
            state.table.sortOrder = sortOrder;
        },

        selectType(state, { event, type }) {
            const index = state.table.selectedTypes.indexOf(type);
            if (event) {
                index === -1 && state.table.selectedTypes.push(type);
            } else {
                index !== -1 && state.table.selectedTypes.splice(index, 1);
            }
        },

        togglePiece(state, payload) {
            const indexOf = state.filter.pieces.indexOf(payload.piece.id);

            if (payload.event && indexOf === -1) {
                Vue.set(state.filter.pieces, state.filter.pieces.length, payload.piece.id);
            } else if (!payload.event && indexOf !== -1) {
                state.filter.pieces.splice(indexOf, 1);
            }
        },

        setFilterFieldsPiece(state, payload) {
            state.filterFields.pieces = payload;
        },

        resetState(state) {
            state.filterFields = {
                pieces: []
            };
            state.filter = {
                pieces: []
            };
            state.table = {
                selectedSplit: 500,
                selectedTypes: [
                    'accumulatedTime',
                    'incrementTime',
                    'speed',
                    'pace',
                    'prognostic',
                    'strokeRate',
                    'eWPS',
                    'dps'
                ],
                sortOrder: null
            };
        }
    },

    actions: {
        togglePiece({ commit }, payload) {
            commit('togglePiece', payload);
        },

        setFilterPieces({ commit }, payload) {
            commit('setFilterFieldsPiece', payload);
            payload.forEach(piece => commit('togglePiece', { event: true, piece }));
        }
    }
};

export default reportsRacingSingleCrewSessionPieces;
